import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import TrademarkRegistration from "./pages/services/TrademarkRegistration";
import CopyrightRegistration from "./pages/services/CopyrightRegistration";
import CompanyFormation from "./pages/services/CompanyFormation";
import TrademarkSearch from "./pages/services/TrademarkSearch";
import TrademarkMonitoring from "./pages/services/TrademarkMonitoring";
import TrademarkRenewal from "./pages/services/TrademarkRenewal";
import AmazonBrandRegistry from "./pages/services/AmazonBrandRegistry";
import ApplicationMain from "./pages/ApplicationMain";
import LandingPage from "./pages/LandingPage";
import { PopupProvider } from "./context/PopupContext";
import PopupModal from "./components/PopupModal";
import { useEffect } from "react";

function App() {

  const handleScroll = () => {
    if(window.scrollY > 50){
        document.querySelectorAll('section:not(first-child)').forEach(item=> item.style.display = "flex");
    }
  }



  useEffect(()=>{
    window.addEventListener('scroll',handleScroll);
    setTimeout(() => {
      handleScroll();
    }, 500);
    return () => {
      window.removeEventListener('scroll',handleScroll);
    }
  },[])

  return (
    <div className="App overflow-x-hidden">
      <BrowserRouter>
        <PopupProvider>
          <ScrollToTop />
          <PopupModal />
          <Routes>
            {/* Landing Page - No Header/Footer */}
            <Route path="/lp" element={<LandingPage />} />
            
            {/* Regular Pages - With Header/Footer */}
            <Route path="*" element={
              <>
                <Header />
                <div className="w-full overflow-x-hidden">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<AboutUs />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<TermsConditions />} />
                    <Route path="/services/trademark-registration" element={<TrademarkRegistration />} />
                    <Route path="/services/copyright-registration" element={<CopyrightRegistration />} />
                    <Route path="/services/company-formation" element={<CompanyFormation />} />
                    <Route path="/services/trademark-search" element={<TrademarkSearch />} />
                    <Route path="/services/trademark-monitoring" element={<TrademarkMonitoring />} />
                    <Route path="/services/trademark-renewal" element={<TrademarkRenewal />} />
                    <Route path="/services/amazon-brand-registry" element={<AmazonBrandRegistry />} />
                    <Route path="/application/main" element={<ApplicationMain />} />
                  </Routes>
                </div>
                <Footer />
              </>
            } />
          </Routes>
        </PopupProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
